import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
    const isAdmin = sessionStorage.getItem("isAdmin") === "true";
    if (!isAdmin) return <Navigate to="/admin" />;
    return children;
}

export default ProtectedRoute;